// src/pages/Dashboard.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      // Try to get admin stats if available
      const response = await api.get('/admin/stats');
      setStats(response.data);
    } catch (error) {
      console.error('Error loading stats:', error);
      // If admin endpoint fails, set basic stats
      setStats({
        users: 0,
        clients: 0,
        total_assessments: 0,
        completed_assessments: 0
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1 style={{ marginBottom: '30px' }}>Dashboard</h1>

      {/* Stats Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '40px'
      }}>
        <StatCard
          title="Total Clients"
          value={stats?.clients || 0}
          color="#3498db"
          link="/clients"
        />
        <StatCard
          title="Total Assessments"
          value={stats?.total_assessments || 0}
          color="#2ecc71"
          link="/assessments"
        />
        <StatCard
          title="Completed"
          value={stats?.completed_assessments || 0}
          color="#27ae60"
        />
        <StatCard
          title="In Progress"
          value={stats?.in_progress_assessments || 0}
          color="#f39c12"
        />
      </div>

      {/* Quick Actions */}
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginBottom: '20px' }}>Quick Actions</h2>
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
          <ActionButton to="/clients">Manage Clients</ActionButton>
          <ActionButton to="/assessments">View Assessments</ActionButton>
          <ActionButton to="/assessments/new">Start New Assessment</ActionButton>
        </div>
      </div>
    </div>
  );
};

const StatCard = ({ title, value, color, link }) => {
  const card = (
    <div style={{
      backgroundColor: color,
      color: 'white',
      padding: '30px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{ fontSize: '14px', opacity: 0.9, marginBottom: '10px' }}>{title}</div>
      <div style={{ fontSize: '36px', fontWeight: 'bold' }}>{value}</div>
    </div>
  );

  return link ? <Link to={link} style={{ textDecoration: 'none' }}>{card}</Link> : card;
};

const ActionButton = ({ to, children }) => (
  <Link
    to={to}
    style={{
      display: 'inline-block',
      padding: '12px 24px',
      backgroundColor: '#3498db',
      color: 'white',
      textDecoration: 'none',
      borderRadius: '4px',
      fontWeight: 'bold',
      transition: 'background-color 0.2s'
    }}
  >
    {children}
  </Link>
);

export default Dashboard;
